module.exports = __webpack_public_path__ + "static/media/9DESA8.6646f8b0.jpg";